import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { InputItem, List, Button, WhiteSpace, Toast, NoticeBar, Picker, TextareaItem } from 'antd-mobile'
import { createForm } from 'rc-form';
import { Decimal } from 'decimal.js';

import { UrlSearch, formatBillUnit } from '../../../utils/utils'
import { GetCompanyList, AddInnerInpourTrade } from '../../../api/usms'
import { AddAgentUserBalance } from '../../../api/order';
// import { formatAmount } from '../utils/common'
import { USpeedoUserType } from '../utils/const';
import CompanyDetail from '../components/CompanyDetail';
import { AclKeys } from '../utils/permissions';
import Permission from '../components/Permission';

const PayPlatform = {
    10: '支付宝',
    20: '银行转账',
    30: '渠道',
    40: '内部充值',
    50: '补贴',
    60: '用户间转账',
    70: '微信',
    80: 'Stripe',
    90: '取消补偿',
};

const PayPlatformMap = {
  Channel: 30
}

// 传递id，获取当前用户详情
function AddTrade(props){

    const [companyInfo, setCompanyInfo] = useState({})
    const [loading, setLoading] = useState(true)
    const [confirmLoading, setConfirmLoading] = useState(false)
    
    const { getFieldProps, getFieldError } = props.form;
    const CompanyId = useMemo(() => {
        return UrlSearch("CompanyId")
    }, []);

    const isAgent = useMemo(() => companyInfo && companyInfo.UserType === USpeedoUserType.CustomAgent, [companyInfo]);
    const initialValues = isAgent ? [PayPlatformMap.Channel] : undefined;

    const filteredPayPlatform = Object.keys(PayPlatform).filter((item) => {
      if (isAgent) {
        if (+item === PayPlatformMap.Channel) {
          return true;
        }
        return false;
      }
  
      return true;
    }).map((item) => {
      return {
        label: PayPlatform[item],
        value: +item,
      };
    });

    const errors = {
        Amount: getFieldError('Amount'),
        PayPlatform: getFieldError('PayPlatform'),
        PayPlatformSerialNo: getFieldError('PayPlatformSerialNo')
    }

    if(!CompanyId){
        props.history.push(`/usms/companylist`)
    }

    const getList = useCallback((data) => {
        setLoading(true);
        GetCompanyList(data).then(res => {
            const { Data, Message } = res;
            if (Data && Data.length) {
                const info = Data[0]
                setCompanyInfo(info);
            } else {
                Toast.fail(Message, 3);
            }
            setLoading(false);
        }).catch(e => {
            Toast.fail(e.message, 3);
            setLoading(false);
        });
    }, [])

    const onCancel = () => {
        props.history.push(`/usms/companylist`)
    }

    const onConfirm = () => {
        props.form.validateFields((error, value) => {
           if(!error){
            const { Amount, Note, PayPlatform, PayPlatformSerialNo } = value
            handleAddInnerInpourTrade({
                CompanyId: companyInfo.CompanyId,
                Amount,
                PayPlatformSerialNo,
                PayPlatform: PayPlatform[0],
                Note
            })
           }
        });
    }

    const handleAddInnerInpourTrade = (data) => {
        const Request = isAgent ? AddAgentUserBalance : AddInnerInpourTrade;

        const params = {
          ...data,
          Amount: Decimal.mul(data.Amount, 10000).toNumber(),
        };

        setConfirmLoading(true)
        Request(params).then(res => {
            const { RetCode, Message } = res;
            if(RetCode !== 0){
                Toast.fail(Message, 3);
            }else{
                Toast.success("充值成功", 3)
                getList({CompanyIds: [Number(CompanyId)]})
            }
            setConfirmLoading(false)
        }).catch(err => {
            Toast.fail(err.message, 3);
            setConfirmLoading(false)
        })
    }

    useEffect(() => {
        getList({CompanyIds: [Number(CompanyId)]})
    }, [getList])

    return <>
        {loading ? <div>
            loading...
        </div>:<div className="container">
            <Permission aclKey={AclKeys.SMSAmonut}>
                <h3 style={{paddingLeft: '10px', paddingBottom: '5px'}}>账户充值</h3>
                <CompanyDetail detailInfo={companyInfo} />
                <List>
                    <InputItem
                        disabled
                        {...getFieldProps('Email', {
                            initialValue: companyInfo.Email
                        })}
                    >当前用户</InputItem>

                    <InputItem
                        disabled
                        {...getFieldProps('CurrentFreeAmount', {
                            initialValue: `${companyInfo.Currency.toUpperCase()} ${formatBillUnit(companyInfo.Amount)}`
                        })}
                    >账户金额</InputItem>
                    
                    <InputItem
                        {...getFieldProps('Amount', {
                            rules: [{ 
                                required: true,
                                type: 'number',
                                validator: (_, value) => {
                                    const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
                                    if(reg.test(value)){
                                        return true
                                    }
                                    return false
                                },
                                message: '金额不合法，最多两位小数' 
                            }]
                        })}
                        placeholder="单位美元，最多2位小数"
                    >充值金额</InputItem>
                    <p style={{color: 'red', paddingLeft: '16px'}}>{ errors.Amount ? errors.Amount.join(',') : null}</p>
                    
                    <Picker 
                        data={filteredPayPlatform} 
                        cols={1} 
                        {...getFieldProps('PayPlatform', {
                            initialValue: initialValues,
                            rules: [{
                                required: true,
                                message: '请选择支付平台' 
                            }]
                        })} 
                    >
                        <List.Item arrow="horizontal">支付平台</List.Item>
                    </Picker>
                    <p style={{color: 'red', paddingLeft: '16px'}}>{ errors.PayPlatform ? errors.PayPlatform.join(',') : null}</p>
                    
                    {companyInfo.UserType === USpeedoUserType.CustomAgent ? null :
                      <TextareaItem
                          {...getFieldProps('PayPlatformSerialNo', {
                              initialValue: '',
                              rules: [{
                                  required: true,
                                  message: '请填写支付平台流水号'
                              }]
                          })}
                          autoHeight
                          placeholder="支付平台流水号"
                          title="流水号"
                      />}
                    <p style={{color: 'red', paddingLeft: '16px'}}>{ errors.PayPlatformSerialNo ? errors.PayPlatformSerialNo.join(',') : null}</p>
                    <TextareaItem
                        {...getFieldProps('Note')}
                        title="备注"
                        autoHeight
                        placeholder="备注"
                    />
                </List>
                <NoticeBar style={{marginTop: '10px'}}>
                    请准确核实收款备注中的验证码是否一致
                </NoticeBar>
                <WhiteSpace />
                <WhiteSpace />
                <WhiteSpace />
                <Button loading={confirmLoading} onClick={onConfirm} type="primary">确定</Button><WhiteSpace />
                <Button onClick={onCancel}>返回</Button><WhiteSpace />
                </Permission>
        </div>}
    </>
}
export default createForm()(withRouter(AddTrade))